import React from 'react'

export default function SelectionToolbar({ selectedCount, onCopy, disabled }) {
  return (
    <div className="flex items-center justify-between mb-3">
      <div className="text-sm text-gray-600">{selectedCount} selected</div>
      <button
        onClick={onCopy}
        disabled={disabled || selectedCount === 0}
        className="h-9 rounded border px-3 text-sm hover:bg-gray-50"
      >
        Copy selected URLs
      </button>
    </div>
  )
}
